<template>
  <div class="top-template about">
    <h1>This is an about page</h1>
  </div>
</template>
